import React from 'react'
import { useNavContext } from "../context/NavContext";
import Nav from './Nav';

const FacturasProveedores = () => {
  const { proximasAVencer, proximosEventos } = useNavContext();

  return (
    <>
      <Nav
        proximasAVencer={proximasAVencer}
        proximosEventos={proximosEventos}
      />

      <h3 style={{paddingLeft: "70px"}}>Facturas de Proveedores</h3>
    </>
  )
}

export default FacturasProveedores;